import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { BaseReport } from './BaseReport';

export class AccountingDimensionReport extends BaseReport {
    _originalTypeClassName = "zERP.BO.AccountingDimensionReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingDimensionReport.translate = translateService;
}
super();
this.Dimensions = [];
this.Data = [];
this._key = this.BaseReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Dimensions:any;
Data:any;
static setDimensions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Dimensions == null) $this.Dimensions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Dimensions.length > 0) {
                    Domain.AccountingDimensionReport.removeDimensions($this, $this.Dimensions[0]);
                }

                Domain.AccountingDimensionReport.addManyDimensions($this, copyItems);
            }
static addManyDimensions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingDimensionReport.addDimensions($this, items[i]);
                }
            }
static addDimensions = ($this, item) => {
                if ($this.Dimensions == null) $this.Dimensions = [];
                if (item == null || $this.Dimensions.indexOf(item) > -1) return;
                $this.Dimensions.push(item);
}
static addRangeDimensions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingDimensionReport.addDimensions($this, item));
            }
static removeDimensions = ($this, item) => {
                if ($this == null || $this.Dimensions == null || $this.Dimensions.indexOf(item) === -1) return;
                var _index = $this.Dimensions.indexOf(item);
                $this.Dimensions.splice(_index, 1);
}
static clearDimensions = ($this) => { $this.Dimensions = null; }
static setData = ($this, items) => {
                if (items == null) items = [];
                if ($this.Data == null) $this.Data = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Data.length > 0) {
                    Domain.AccountingDimensionReport.removeData($this, $this.Data[0]);
                }

                Domain.AccountingDimensionReport.addManyData($this, copyItems);
            }
static addManyData = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingDimensionReport.addData($this, items[i]);
                }
            }
static addData = ($this, item) => {
                if ($this.Data == null) $this.Data = [];
                if (item == null || $this.Data.indexOf(item) > -1) return;
                $this.Data.push(item);
}
static addRangeData = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingDimensionReport.addData($this, item));
            }
static removeData = ($this, item) => {
                if ($this == null || $this.Data == null || $this.Data.indexOf(item) === -1) return;
                var _index = $this.Data.indexOf(item);
                $this.Data.splice(_index, 1);
}
static clearData = ($this) => { $this.Data = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BaseReportKey == null || $this.BaseReportKey == 0;
            }


}